import { defineComponent } from '@vue/composition-api';
import __vue_component__ from '../SdsIcon/SdsIcon.vue.js';
import __vue_component__$1 from '../SdsBadge/SdsBadge.vue.js';

var script = defineComponent({
    name: 'SdsQuickLink',
    props: {
        backgroundImageUrl: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        imageUrl: {
            type: String,
            required: true,
        },
        badgeText: {
            type: String,
            default: '',
            required: false,
        },
        isExpandedView: {
            type: Boolean,
            default: false,
        },
        seoHref: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    emits: ['click'],
    components: {
        SdsIcon: __vue_component__,
        SdsBadge: __vue_component__$1,
    },
});

export default script;
